import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const AccountOpeningV2OpeningTakingTooLongStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={8} direction="column">
      <FDStack spacing={2} direction="column">
        <MetaControlField attr="title" />
        <MetaControlField attr="description" />
        <MetaLayoutRemainingFields noAccordion />
      </FDStack>
      <PrimaryActionButtonRel
        relationship={resource.relationship(fr.relationships.exit.name)}
        alignSelf={'center'}
      />
    </FDStack>
  );
};
